<template>
  <div :class="$attrs.class">
    <div class="dates">
      <label>
        <span class="sr-only">From</span>
        <input
          type="date"
          :disabled="disabled"
          :value="from"
          :max="through"
          @input="emitStart({ selected: 'pickRange', through: through, from: $event.target.value })"
        />
      </label>
      <font-awesome-icon
        :icon="['fas', 'long-arrow-alt-right']"
        class="icon alt between-dates"
        aria-hidden="true"
      />
      <label>
        <span class="sr-only">To</span>
        <input
          type="date"
          :disabled="disabled"
          :value="through"
          :min="from"
          @input="emitStart({ selected: 'pickRange', from: from, through: $event.target.value })"
        />
      </label>
    </div>
    <button
      :class="{ active: listShowing === 'all' }"
      :disabled="listShowing === 'all' || disabled"
      @click="select('all')"
    >
      All Time
    </button>
    <button
      :class="{ active: listShowing === 'recent' }"
      :disabled="listShowing === 'recent' || disabled"
      @click="select('recent')"
    >
      Past 30 Days
    </button>
  </div>
</template>

<script>
import moment, { isMoment } from 'moment';

export default {
  name:'HeaderButtons',

  props: {
    from: {
      type: String,
      required: false,
      default: null,
    },
    through: {
      type: String,
      required: false,
      default: null,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    }
  },

  data() {
    return {
      debounce: null,
      debounceTime: 250,
    }
  },
  computed: {
    listShowing() {
      const today = moment();
      const daysBetweenThroughAndToday = moment(this.through).diff(today, 'day');
      const daysBetweenFromAndToday = moment(this.from).diff(today, 'day');

      if (this.from == null && daysBetweenThroughAndToday < 1) {
        return 'all';
      }

      if (daysBetweenFromAndToday === -30 && daysBetweenThroughAndToday === 0) {
        return 'recent';
      }

      return 'pickRange';
    },
  },
  mounted() {
    this.select('recent');
  },
  methods: {
    select(selection) {
      switch (selection) {
        case 'all': {
          this.emitExact({
            selected: selection,
            from: null,
            through: moment()
          })
        } break;
        case 'recent': {
          this.emitExact({
            selected: selection,
            from: moment().add(-30, 'day'),
            through: moment()
          })
        } break;
        case 'pickRange': {
          this.emitStart({
            selected: selection,
            from: this.from,
            through: this.through
          })
        } break;
      }
    },
    emitStart({ selected, from, through }) {
      if (from && !isMoment(from)) {
        from = moment(from);
      }
      if (through && !isMoment(through)) {
        through = moment(through);
      }

      from = from ? from.startOf('day').toISOString() : null;
      through = through ? through.endOf('day').toISOString() : null;

      if (this.debounce) {
        clearTimeout(this.debounce);
      }
      this.debounce = setTimeout(() => this.$emit('change', { selected, from, through }, this.debounceTime));
    },
    emitExact({ selected, from, through }) {
      if (from && !isMoment(from)) {
        from = moment(from).toISOString();
      }
      if (through && !isMoment(through)) {
        through = moment(through).toISOString();
      }
      if (this.debounce) {
        clearTimeout(this.debounce);
      }
      this.debounce = setTimeout(() => this.$emit('change', { selected, from, through }, this.debounceTime));
    }
  }
}
</script>

<style lang="scss" scoped>
.dates {
  color-scheme: light;
  display: flex;
  justify-content: center;
  flex-wrap: nowrap;
  align-items: center;
  background: #fff;
  border-radius: 8px;
  border-right: 1px solid #d1d1d1;
  padding: 0;
  margin: 0;
  height: 46px;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  text-align: center;

  @media screen and (min-width: $md-min) {
    height: 46px;
    flex-wrap: nowrap;
  }

  label {
    margin: 0;
  }

  input {
    border: 0;
    background: transparent;
    line-height: 2;
    font-size: 14px;
    font-weight: 500;
    text-transform: uppercase;
    max-width: 145px;
    height: 46px;
    padding: 0 16px;
  }

  svg {
    opacity: 0.8;
  }

  &:hover {
    box-shadow: 0 2px 4px rgb(0 0 0 / 18%);
    border-color: #bababa;
  }
}
</style>
